// extracted by mini-css-extract-plugin
module.exports = {"chat-container":"Chat_chat-container__1x4oj"};